<template>
  <EmptyView>
    <template v-if="noLogin" #content>
      <div>
        <a @click="openLogin">{{ $t('deng-lu-zhu-ce') }}</a>
        {{ $t('kuai-lai-ti-yan') }}
      </div>
    </template>
  </EmptyView>
</template>
<script name="EmptyView" lang="ts" setup>
const noLogin = ref(false)

const session = useSession()

const openLogin = () => {
  goLogin({ redirect: encodeURIComponent(location.href) })
}

onMounted(() => {
  noLogin.value =
    typeof session.value === 'undefined' ||
    Object.keys(session.value ?? {}).length === 0
})
</script>
<style lang="scss" scoped></style>
